import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteBoardLinkSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.89452 14.4333L8.67471 15.6531C8.06923 16.199 7.27733 16.4917 6.46236 16.4708C5.64738 16.4499 4.87151 16.1171 4.2948 15.5408C3.71808 14.9646 3.38451 14.1891 3.3629 13.3741C3.34129 12.5592 3.63329 11.767 4.17865 11.161L5.39846 9.94123C5.64883 9.69121 5.78963 9.35197 5.78988 8.99814C5.79013 8.64431 5.64981 8.30487 5.39979 8.0545C5.14977 7.80413 4.81053 7.66333 4.4567 7.66309C4.10287 7.66284 3.76343 7.80316 3.51306 8.05318L2.29458 9.27299C1.19868 10.3689 0.583008 11.8552 0.583008 13.4051C0.583008 14.9549 1.19868 16.4413 2.29458 17.5372C3.39048 18.6331 4.87684 19.2488 6.42668 19.2488C7.97652 19.2488 9.46288 18.6331 10.5588 17.5372L11.7786 16.3187C12.0286 16.0689 12.1691 15.7299 12.1693 15.3765C12.1694 15.023 12.0291 14.684 11.7793 14.434C11.5294 14.1839 11.1905 14.0434 10.837 14.0433C10.4836 14.0432 10.1445 14.1835 9.89452 14.4333Z"
          fill="#878A92"
        />
        <path
          d="M10.8071 7.14118L7.03767 10.9107C6.78782 11.1605 6.64746 11.4994 6.64746 11.8527C6.64746 12.206 6.78782 12.5449 7.03767 12.7947C7.28751 13.0446 7.62637 13.1849 7.9797 13.1849C8.33303 13.1849 8.6719 13.0446 8.92174 12.7947L12.6912 9.02525C12.9411 8.77541 13.0814 8.43655 13.0814 8.08322C13.0814 7.72989 12.9411 7.39102 12.6912 7.14118C12.4414 6.89134 12.1025 6.75098 11.7492 6.75098C11.3958 6.75098 11.057 6.89134 10.8071 7.14118Z"
          fill="#878A92"
        />
        <path
          d="M17.4333 2.39831C16.8907 1.85562 16.2465 1.42512 15.5375 1.13141C14.8285 0.837696 14.0686 0.686523 13.3012 0.686523C12.5338 0.686523 11.7739 0.837696 11.0649 1.13141C10.3559 1.42512 9.71168 1.85562 9.16908 2.39831L7.94927 3.6168C7.69925 3.86664 7.55872 4.20557 7.55859 4.55903C7.55847 4.91248 7.69876 5.25151 7.9486 5.50153C8.19845 5.75155 8.53738 5.89208 8.89084 5.89221C9.24429 5.89233 9.58332 5.75204 9.83334 5.5022L11.0531 4.28239C11.6586 3.73648 12.4505 3.44379 13.2655 3.46468C14.0805 3.48557 14.8563 3.81845 15.4331 4.39465C16.0098 4.97086 16.3433 5.74644 16.365 6.56139C16.3866 7.37634 16.0946 8.1685 15.5492 8.77447L14.3294 9.99427C14.079 10.2443 13.9382 10.5835 13.938 10.9374C13.9377 11.2912 14.0781 11.6306 14.3281 11.881C14.5781 12.1314 14.9173 12.2722 15.2712 12.2724C15.625 12.2727 15.9644 12.1323 16.2148 11.8823L17.4333 10.6625C17.976 10.1199 18.4065 9.47573 18.7002 8.76673C18.9939 8.05774 19.1451 7.29784 19.1451 6.53042C19.1451 5.76299 18.9939 5.00309 18.7002 4.2941C18.4065 3.5851 17.976 2.94091 17.4333 2.39831Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default WhiteBoardLinkSVG;
